<template>
  <v-row align="center" justify="center" class="backgroundColor">
    <v-dialog v-model="seguirServicioModal" persistent max-width="70%">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row align="center" justify="center">
            <img src="../assets/follow-service.svg" width="35%" class="ma-3" />
          </v-row>

          <v-row align="center" justify="center">
            <h1>Sigue tu servicio</h1>
          </v-row>

          <v-row align="center" justify="center">
            <v-col cols="8">
              <v-row align="center" justify="center">
                <p class="text-center">
                  Ingresa tu número de teléfono que asociaste a tu servicio.
                </p>
              </v-row>
            </v-col>
          </v-row>

          <v-row align="center" justify="center">
            <v-col cols="8">
              <v-form ref="form">
                <v-row align="center" justify="center">
                  <v-text-field
                    v-model="phoneNum"
                    outlined
                    label="Número de celular:"
                    placeholder="10 dígitos"
                    :counter="10"
                    :rules="phoneRules"
                    maxlength="10"
                  >
                  </v-text-field>
                </v-row>
              </v-form>
            </v-col>
          </v-row>

          <v-row align="center" justify="center">
            <v-col cols="8">
              <v-row align="center" justify="center">
                <v-btn
                  color="primary"
                  block
                  rounded
                  @click="reastrearPedido()"
                  :disabled="!phoneNum"
                >
                  Rastrear
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Axios from "axios";
import { mapFields } from "vuex-map-fields";
import config from "../config"

export default {
  computed: {
    ...mapFields([
      "seguirServicioModal",
      "seguirServicioNumberUuid",
      "loader",
      "showMessage",
      "message",
    ]),
  },
  data() {
    return {
      phoneNum: "",
      phoneRules: [
        (v) => !!v || "El número celular es requerido.", //
        (v) => (v && v.length <= 10) || "El número debe ser de 10 dígitos",
        (v) => (v && v.length >= 10) || "El número debe ser de 10 dígitos",
        (v) => RegExp("[0-9]+$").test(v) || "Ingresa sólo números",
      ],
    };
  },
  methods: {
    close() {
      this.seguirServicioModal = false;
      this.$refs.form.reset();
    },
    reastrearPedido() {
      if (this.$refs.form.validate()) {
        this.getStatus(this.phoneNum);
      }
    },
    getStatus(phoneNumber) {
      this.loader = true;
      let api = Axios.get(
        config.apiBaseUrl + "/services/" + phoneNumber + "/active-service",
        {
          headers: {
            "x-api-key": config.apiKey,
          },
        }
      )
        .then((response) => {
          if (response.data.statusId === 3) {
            this.seguirServicioNumberUuid = response.data.uuidService;
            this.close();
            this.$router.push({ name: "Tracing" });
          } else if (
            response.data.statusId === 1 ||
            response.data.statusId === 2
          ) {
            this.seguirServicioNumberUuid = response.data.uuidService;
            this.close();
            this.$router.push({ name: "Waiting" });
          } else if (response.data.statusId === 5) {
            this.seguirServicioNumberUuid = response.data.uuidService;
            this.close();
            this.$router.push({ name: "Qualify" });
          } 
          this.loader = false;
        })
        .catch((error) => {
          this.loader = false;
          this.message = "No hay servicio registrado a ese número.";
          this.showMessage = true;
        });
    },
  },
};
</script>
<style scoped>
.backgroundColor {
  background-color: #f1f3f6;
}
</style>